import moment from 'moment';
import { DocumentData, QueryDocumentSnapshot } from 'firebase/firestore';

export function getTitleFromDocByPath(doc: QueryDocumentSnapshot<DocumentData>): string {
  const pathWithoutId = doc.ref.path;
  switch (pathWithoutId) {
    default:
      return doc.id;
  }
}

export function getDescriptionFromDocByPath(doc: QueryDocumentSnapshot<DocumentData>): string {
  const { path } = doc.ref;
  const pathWithoutId = path.substr(0, path.lastIndexOf('/'));
  const collection = pathWithoutId.substr(pathWithoutId.lastIndexOf('/'));
  if (collection.includes('matches')) {
    return `Start date: ${moment(doc.data().startDate).format('YYYY-MM-DD HH:mm')}`;
  }
  return '';
}

export function getImageFromDocByPath(doc: QueryDocumentSnapshot<DocumentData>): string {
  const pathWithoutId = doc.ref.path;
  switch (pathWithoutId) {
    default:
      return '';
  }
}

export function getColTitleByPath(path: string): string {
  switch (path) {
    default:
      return path;
  }
}

export function getColDescriptionByPath(path: string): string {
  switch (path) {
    default:
      return path;
  }
}

export function getColImageByPath(path: string): string {
  switch (path) {
    default:
      return '';
  }
}
